<template>
  <section id="bumiKini" ref="bumiKini" v-on:wheel="wheelChanged">
    <Header :class="{header: true}" v-on:login="$emit('login')"
      :scrolled="true"/>
    <div :class="{sectionNav: true, navBlack: currnetSx === 3
      || currnetSx === 6 || currnetSx === 1}">
      <div class="navUp" v-on:click="prevSection"
        v-if="currnetSx > 0"></div>
      <div class="navDown" v-on:click="nextSection"
        v-if="currnetSx < sxAnimate.length"></div>
    </div>
    <div :class="{sectionItem: true, section1: true, an1: sxAnimate[0].an1, an2: sxAnimate[0].an2}">
      <div class="sectionItemWrapper">
        <div class="text">
          <h3>Faktor-faktor</h3>
          <p>Suhu bumi kian meningkat dari tahun ke tahun, mengantarkan kita semakin dekat
          pada ancaman-ancaman krisis iklim yang jauh lebih buruk.</p>

          <p>Meski sejumlah fenomena alam turut menjadi faktor munculnya gas rumah kaca (GRK),
          tetapi aktivitas manusia lah yang justru menghasilkan emisi GRK pada tingkat yang
          semakin ekstrem hingga membuat bumi terus memanas.</p>
        </div>
        <div class="sectionR">
          <div class="sun"></div>
          <div class="building"></div>
          <div class="smoke1"></div>
          <div class="smoke2"></div>
          <div class="smoke3"></div>
        </div>
      </div>
    </div>
    <div :class="{sectionItem: true, section2: true, an1: sxAnimate[1].an1, an2: sxAnimate[1].an2}">
      <h4 class="scTtl"><span>Gas-gas yang berkontribusi terhadap
        efek rumah kaca antara lain:</span></h4>
      <div class="sectionR">
        <div class="s2item s2itemTop">
          <div class="s2img s2img1"></div>
          <h4>Karbon Dioksida (CO2)</h4>
        </div>
        <div class="s2item s2itemTop">
          <div class="s2img s2img2"></div>
          <h4>Uap Air (H2O)</h4>
        </div>
        <div class="s2item s2itemTop">
          <div class="s2img s2img3"></div>
          <h4>Hidrofluorokarbon (HFC)</h4>
        </div>
        <div class="s2item s2itemBot">
          <div class="s2img s2img4"></div>
          <h4>Metana (CH4)</h4>
        </div>
        <div class="s2item s2itemBot">
          <div class="s2img s2img5"></div>
          <h4>Dinitrogen Oksida (N2O)</h4>
        </div>
        <div class="s2item s2itemBot">
          <div class="s2img s2img6"></div>
          <h4>Klorofluorokarbon (CFC)</h4>
        </div>
      </div>
    </div>
    <div :class="{sectionItem: true, section3: true, an1: sxAnimate[2].an1, an2: sxAnimate[2].an2}">
      <h4 class="scTtl">Lalu, sektor-sektor apa saja dalam aktivitas kita yang sebenarnya
        memproduksi sedemikian banyak emisi GRK?</h4>
    </div>
    <div :class="{sectionItem: true, section4: true, an1: sxAnimate[3].an1, an2: sxAnimate[3].an2}">
      <h4 class="scTtl">Emisi Gas Rumah Kaca Global berdasarkan Sektor</h4>
      <div class="grkCnt">
        <div class="grk grk1"></div>
        <div class="grk grk2"></div>
      </div>
    </div>
    <div :class="{sectionItem: true, section5: true, an1: sxAnimate[4].an1, an2: sxAnimate[4].an2}">
      <div class="sectionItemWrapper">
        <div class="scTtl">
          <p>Sektor energi menjadi faktor utama dari aktivitas manusia yang
          menghasilkan emisi GRK terbanyak secara global. Sektor ini turut mencakup
          aktivitas kita sehari-hari seperti transportasi, listrik, bangunan, manufaktur,
          konstruksi, dan penggunaan bahan bakar lainnya.</p>
          <p>Kemudian menyusul beberapa sektor lainnya yang menyumbang emisi GRK global,
          seperti sektor pertanian, kehutanan dan penggunaan lahan, industri, serta sampah.</p>
        </div>
        <div class="sectionR">
          <div class="building"></div>
          <div class="smoke1"></div>
          <div class="smoke2"></div>
          <div class="smoke3"></div>
          <div class="barrel"></div>
          <div class="cars"></div>
          <div class="plane"></div>
          <div class="cloud1"></div>
          <div class="cloud2"></div>
          <div class="escavator"></div>
        </div>
      </div>
      <div class="groundBg"></div>
    </div>
    <div :class="{sectionItem: true, section6: true, an1: sxAnimate[5].an1, an2: sxAnimate[5].an2}">
      <div class="sectionItemWrapper">
        <div class="sectionL">
          <div class="earthIcon">
            <div class="banner5"></div>
            <div class="ribbon"></div>
          </div>
          <p class="scSub">Faktanya, lebih dari setengah emisi global disumbang oleh
            10 negara saja. Indonesia merupakan negara yang masuk di dalamnya sebagai
            negara penghasil emisi terbesar kelima di dunia, dengan menyumbang hingga
            1703.86 MtCO2e atau setara dengan 3,4% emisi dunia.</p>
        </div>
        <div class="sectionR">
          <div class="theImg">
            <div class="imgCnt">
              <img src="../assets/grafik-penyumbang-erk.png">
            </div>
            <div class="imgCaption">(Sumber: <a href="https://www.climatewatchdata.org"
              target="_blank">climatewatchdata.org</a>)</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{sectionItem: true, section7: true, an1: sxAnimate[6].an1, an2: sxAnimate[6].an2}">
      <div class="sectionItemWrapper">
        <div class="scTtl">Apa Saja Faktor Penyebab Emisi di Indonesia?</div>
        <div class="erkCnt">
          <div class="erkItem erk1">
            <div class="erka"></div>
            <div class="erkb"></div>
          </div>
          <div class="erkItem erk2">
            <div class="erka"></div>
            <div class="erkb"></div>
          </div>
          <div class="erkItem erk3">
            <div class="erka"></div>
            <div class="erkb"></div>
          </div>
        </div>
        <div class="erkInfo">
          Sektor Energi dan Kehutanan, Dua Penyumbang GRK Terbesar
        </div>
        <div class="erkLegend">
          <div class="legend legend1">
            <div class="legendItem">
              <div class="lIcon ippu"></div>
              IPPU: Proses Industri dan Penggunaaan Produk
            </div>
          </div>
          <div class="legend legend2">
            <div class="legendItem">
              <div class="lIcon sampah"></div>
              Sampah
            </div>
            <div class="legendItem">
              <div class="lIcon pertanian"></div>
              Pertanian
            </div>
          </div>
          <div class="legend legend3">
            <div class="legendItem">
              <div class="lIcon energi"></div>
              Energi
            </div>
            <div class="legendItem">
              <div class="lIcon kehutanan"></div>
              Kehutanan
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{sectionItem: true, section8: true, an1: sxAnimate[7].an1, an2: sxAnimate[7].an2}">
      <div class="sectionItemWrapper">
        <div class="scTtl">
          <div class="ttlAn1">
            <p>Sejalan dengan faktor emisi global, sektor energi menjadi faktor utama
              penghasil emisi terbesar di Indonesia, di atas sektor kehutanan, pertanian,
              sampah, dan industri. Meski begitu, upaya pemerintah untuk menekan emisi,
            khususnya dari sektor energi belum menunjukkan langkah yang serius dan ambisius.</p>
            <p>Kebijakan-kebijakan justru masih berpihak pada penggunaan energi kotor,
              khususnya PLTU batubara yang dapat menghasilkan emisi hingga 168 juta ton/tahun.
              Bahkan dengan komitmen iklim (NDC) yang dicanangkan Indonesia, sektor energi
              diprediksi masih akan terus meningkat sebagai penghasil emisi nomor satu
            yang menyumbang hingga 58% dari total emisi Indonesia.</p>
          </div>
          <div class="ttlAn2">
            <div class="btn" v-on:click="$router.push('/bumi-kini/dampak-yang-mengancam')">
              <div class="btnL"></div>
              <div class="btnL2"></div>
              <span>Selanjutnya</span>
            </div>
            <div class="factor">Dampak Yang Mengancam</div>
          </div>
        </div>
        <div class="sectionR">
          <div class="car"></div>
          <div class="bin"></div>
        </div>
      </div>
    </div>
    <div class="sectionFooter"><Footer></Footer></div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  components: { Header, Footer },
  data() {
    return {
      currnetSx: 0,
      sxAnimate: [
        { an1: false, an2: false },
        { an1: false, an2: false },
        { an1: false, an2: false },
        { an1: false, an2: false },
        { an1: false, an2: false },
        { an1: false, an2: false },
        { an1: false, an2: false },
        { an1: false, an2: false },
      ],
      scrolling: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
    window.addEventListener('resize', this.onResized);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
    window.removeEventListener('resize', this.onResized);
  },
  beforeDestroy() {
    document.body.classList.remove('hideoverflow');
  },
  methods: {
    ...mapActions([
      'chMenuActive',
    ]),
    doNothing() {},
    onScrolled(e) {},
    onResized() {
      if (window.innerWidth >= 960) this.doScroll();
    },
    wheelChanged(e) {
      if (window.innerWidth <= 960) return;
      if (this.scrolling) return;
      if (e.wheelDeltaY < 0) {
        this.nextSection();
      } else if (e.wheelDeltaY > 0) {
        this.prevSection();
      }
    },
    showSection(sx) {
      this.sxAnimate[sx].an1 = true;
      setTimeout(() => {
        this.sxAnimate[sx].an2 = true;
      }, 1300);
    },
    removeAnimation(sx) {
      this.sxAnimate[sx].an2 = false;
      setTimeout(() => {
        this.sxAnimate[sx].an1 = false;
      }, 900);
    },
    nextSection() {
      this.scrolling = true;
      setTimeout(() => {
        this.scrolling = false;
      }, 1000);
      this.currnetSx += 1;
      this.doScroll();
      if (this.sxAnimate[this.currnetSx]) {
        setTimeout(() => {
          this.removeAnimation(this.currnetSx - 1);
        });
        setTimeout(() => {
          this.showSection(this.currnetSx);
        }, 1000);
      }
    },
    prevSection() {
      this.scrolling = true;
      setTimeout(() => {
        this.scrolling = false;
      }, 1000);
      if (this.currnetSx < 1) return;
      this.currnetSx -= 1;
      this.doScroll();
      if (this.sxAnimate[this.currnetSx + 1]) {
        setTimeout(() => {
          this.removeAnimation(this.currnetSx + 1);
        });
        setTimeout(() => {
          this.showSection(this.currnetSx);
        }, 300);
      }
    },
    doScroll() {
      this.$refs.bumiKini.scroll({
        top: this.currnetSx * window.innerHeight * 86 / 100,
        left: 0,
        behavior: 'smooth',
      });
    },
  },
  mounted() {
    document.body.classList.add('hideoverflow');
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Faktor-faktor - Bumi Butuh Aksi';
    this.showSection(0);
    this.chMenuActive('bumi-kini');
  },
};
</script>

<style scoped lang="scss">
.sectionNav{
  position: absolute;
  left: 50%; bottom: 6vh;
  margin-left: -40px;
  z-index: 99;
  width: 80px;
  height: 36px;
  @media (max-width: 960px) {
    display: none;
  }
  .navUp{
    width: 36px; height: 36px;
    border: #fff 2px solid;
    border-radius: 23px;
    box-sizing: border-box;
    position: absolute; left: 0; bottom: 0;
    transition: all .2s ease;
    cursor: pointer;
    background-image: url(../assets/arrow-up-white.png);
    background-position: center;
    background-size: 18px auto;
    background-repeat: no-repeat;
    &:hover{
      height: 46px;
    }
  }
  .navDown{
    width: 36px; height: 36px;
    border: #fff 2px solid;
    border-radius: 23px;
    box-sizing: border-box;
    position: absolute; right: 0; top: 0;
    transition: all .2s ease;
    cursor: pointer;
    background-image: url(../assets/arrow-down-white.png);
    background-position: center;
    background-size: 18px auto;
    background-repeat: no-repeat;
    &:hover{
      height: 46px;
    }
  }
  &.navBlack{
    .navUp{
      border-color: #222;
      background-image: url(../assets/arrow-up-black.png);
      opacity: .7;
    }
    .navDown{
      border-color: #222;
      background-image: url(../assets/arrow-down-black.png);
      opacity: .7;
    }
  }
}
.section1{
  background-color: #098C7F;
  // background-image: url(../assets/texture-bg.png);
  overflow: hidden;
  @media (max-width: 960px) {
    padding-bottom: 440px;
  }
  @media (max-width: 680px) {
    padding-bottom: 280px;
  }
  .text{
    position: absolute;
    left: 100px; top: 50%;
    transform: translateY(-50%);
    max-width: 660px;
    color: #fff;
    z-index: 10;
    @media (max-width: 1369px) {
      max-width: 560px;
    }
    @media (max-width: 1169px) {
      left: 60px;
    }
    @media (max-width: 960px) {
      position: static;
      transform: none;
      width: auto;
      max-width: none;
      padding: 40px;
    }
    @media (max-width: 680px) {
      padding: 30px 16px;
    }
    h3{
      font-size: 70px;
      line-height: 1.1;
      margin: 0 0 40px;
      margin-left: -5px;
      transform: translateX(-700px);
      font-weight: 800;
      transition: all .9s ease;
      opacity: 0;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
        font-size: 64px;
      }
      @media (max-width: 680px) {
        font-size: 40px;
        margin: 0 0 16px;
      }
    }
    p{
      transform: translateX(-700px);
      transition: all .9s ease;
      font-size: 20px;
      line-height: 1.4;
      opacity: 0;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
      }
      @media (max-width: 680px) {
        font-size: 18px;
      }
    }
  }
  .sectionR{
    position: absolute;
    right: 20px;
    width: 720px;
    height: 600px;
    bottom: 0;
    @media (max-width: 1369px) {
      transform: scale(.94) translate(18px, 18px);
    }
    @media (max-width: 1169px) {
      transform: scale(.86) translate(200px, 48px);
    }
    @media (max-width: 960px) {
      right: auto; left: 50%;
      transform: scale(.8) translate(-50%, 76px);
      margin-left: -80px;
    }
    @media (max-width: 680px) {
      transform: scale(.54) translate(-50%, 260px);
      margin-left: -160px;
    }
    .building{
      width: 600px; height: 600px;
      right: 100px; bottom: -2px;
      position: absolute;
      background-image: url(../assets/pltu.png);
      background-size: 100% auto;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 3; opacity: 0;
      transform: translateY(320px);
      transition: all .9s ease;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
      }
    }
    .smoke1{
      width: 130px; height: 0;
      left: 87px; bottom: 100px;
      position: absolute;
      background-image: url(../assets/smoke-faktor2.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 1; opacity: 0;
      transition: all .9s ease;
      @media (max-width: 960px) {
        opacity: 1;
        height: 320px;
      }
    }
    .smoke2{
      width: 94px; height: 0;
      left: 250px; bottom: 284px;
      position: absolute;
      background-image: url(../assets/smoke2-fakto2.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 1; opacity: 0;
      transition: all .9s ease;
      @media (max-width: 960px) {
        opacity: 1; height: 260px; bottom: 324px;
      }
    }
    .smoke3{
      width: 84px; height: 0;
      left: 350px; bottom: 284px;
      position: absolute;
      background-image: url(../assets/smoke3-faktor2.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 1; opacity: 0;
      transition: all .9s ease;
      @media (max-width: 960px) {
        opacity: 1; height: 260px; bottom: 324px;
      }
    }
    .sun{
      width: 1200px; height: 1200px;
      left: -200px; top: 360px;
      position: absolute;
      transition: all .9s ease;
      &:before{
        position: absolute;
        right: 0; top: 0;
        content: "";
        width: 140px; height: 140px;
        background-image: url(../assets/sun.png);
        background-size: 100% auto;
        background-position: center;
      }
      @media (max-width: 960px) {
        transform: rotate(-30deg);
      }
    }
  }
  &.an1{
    .text{
      h3{
        transform: translateY(0);
        opacity: 1;
      }
    }
    .building{
      opacity: 1;
      transform: none;
    }
  }
  &.an2{
    .text{
      p{
        transform: translateY(0);
        opacity: 1;
      }
    }
    .sun{
      transform: rotate(-30deg);
    }
    .smoke1, .smoke2, .smoke3{
      opacity: 1;
    }
    .smoke1{
      height: 320px;
    }
    .smoke2{
      height: 260px;
      bottom: 324px;
    }
    .smoke3{
      height: 260px;
      bottom: 324px;
    }
  }
}
.section2{
  background-color: #FFE06A;
  overflow: hidden;
  .scTtl{
    color: #555A84;
    text-transform: uppercase;
    font-size: 26px;
    font-weight: 800;
    position: absolute;
    left: 0; top: 50%;
    z-index: 2; opacity: 0;
    transition: all .9s ease;
    padding: 136px 116px 0;
    width: 460px; height: 460px;
    margin-top: -230px;
    box-sizing: border-box;
    transform: translateX(-460px);
    @media (max-width: 1369px) {
      width: 400px; height: 400px;
      transform: translateX(-400px);
      margin-top: -200px;
      padding: 112px 86px 0;
    }
    @media (max-width: 1169px) {
      width: 300px; height: 300px;
      font-size: 20px;
      padding: 80px 62px 0;
      margin-top: -150px;
    }
    @media (max-width: 960px) {
      position: static;
      left: 0; top: 0;
      transform: none;
      opacity: 1;
      width: auto; height: auto;
      margin: 0; padding: 40px;
      background-color: #fff;
    }
    @media (max-width: 680px) {
      padding: 30px 16px;
      font-size: 18px;
      line-height: 1.4;
    }
    span{
      position: relative;
      z-index: 2;
    }
    &:before{
      content: "";
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      transition: all .9s ease;
      background-color: #fff;
      transform: translateX(-460px);
      @media (max-width: 960px) {
        display: none;
      }
    }
  }
  .sectionR{
    position: absolute;
    top: 20px; bottom: 20px; right: 100px; left: 500px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    @media (max-width: 1169px) {
      left: 340px;
      right: 60px;
    }
    @media (max-width: 960px) {
      position: static;
      padding: 40px 20px 60px;
    }
    @media (max-width: 680px) {
      padding: 30px 4px;
    }
    .s2item{
      width: 33.33333%;
      transform: translateY(240px);
      opacity: 0;
      transition: all .9s ease;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
      }
      @media (max-width: 680px) {
        width: 50%;
      }
      &.s2itemTop{
        margin: auto 0 20px;
      }
      &.s2itemBot{
        margin: 20px 0 auto;
      }
      .s2img{
        width: 220px; height: 220px;
        @media (max-width: 1369px) {
          width: 160px; height: 160px;
        }
        @media (max-width: 1169px) {
          width: 120px; height: 120px;
        }
        margin: 0 auto;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        &.s2img1{
          background-image: url(../assets/s2-item-img-1.png);
        }
        &.s2img2{
          background-image: url(../assets/s2-item-img-2.png);
        }
        &.s2img3{
          background-image: url(../assets/s2-item-img-3.png);
        }
        &.s2img4{
          background-image: url(../assets/s2-item-img-4.png);
        }
        &.s2img5{
          background-image: url(../assets/s2-item-img-5.png);
        }
        &.s2img6{
          background-image: url(../assets/s2-item-img-6.png);
        }
      }
      h4{
        font-weight: 800;
        text-align: center;
        font-size: 18px;
        transform: translateX(320px);
        opacity: 0;
        transition: all .9s ease;
        @media (max-width: 960px) {
          transform: none;
          opacity: 1;
        }
      }
    }
  }
  &.an1{
    .scTtl{
      transform: none;
      opacity: 1;
    }
    .sectionR{
      .s2item{
        opacity: 1;
        transform: none;
      }
    }
  }
  &.an2{
    .scTtl{
      &:before{
        transform: none;
        opacity: 1;
      }
    }
    .sectionR{
      .s2item{
        h4{
          opacity: 1;
          transform: none;
        }
      }
    }
  }
}
.section3{
  background-color: #555A84;
  background-image: url(../assets/faktor2-section3.png);
  background-size: 100% auto !important;
  background-position: bottom center !important;
  background-repeat: no-repeat;
  @media (max-width: 960px) {
    padding: 120px 40px;
  }
  @media (max-width: 680px) {
    padding: 100px 16px;
  }
  .scTtl{
    color: #fff;
    font-size: 70px;
    font-weight: 800;
    line-height: 1;
    margin: 0;
    width: 1200px;
    position: absolute;
    left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    margin-top: 260px;
    opacity: 0;
    transition: all .9s ease;
    @media (max-width: 1369px) {
      font-size: 56px;
      width: 960px;
    }
    @media (max-width: 1169px) {
      font-size: 46px;
    }
    @media (max-width: 960px) {
      position: static;
      margin: 0; opacity: 1;
      transform: none;
      line-height: 1.2;
      width: auto;
    }
    @media (max-width: 680px) {
      font-size: 28px;
    }
  }
  &.an1{
    .scTtl{
      margin-top: 0;
      opacity: 1;
    }
  }
}
.section4{
  background-color: #F4F6F1;
  @media (max-width: 960px) {
    padding: 40px 40px 60px;
  }
  @media (max-width: 680px) {
    padding: 30px 16px 40px;
  }
  .scTtl{
    color: #444;
    margin: 0;
    position: absolute;
    top: 60px; left: 0; right: 0;
    text-align: center;
    font-weight: 800;
    font-size: 30px;
    transform: translateY(100px);
    opacity: 0;
    transition: all .9s ease;
    z-index: 3;
    @media (max-width: 960px) {
      position: static;
      transform: none;
      opacity: 1;
      margin-bottom: 40px;
    }
    @media (max-width: 680px) {
      font-size: 20px;
    }
  }
  .grkCnt{
    position: absolute;
    left: 0; right: 0; top: 126px; bottom: 100px;
    @media (max-width: 960px) {
      position: relative;
      top: auto; bottom: auto;
      height: 60vw;
    }
    .grk{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-position: center;
      background-size: auto 100%;
      background-repeat: no-repeat;
      opacity: 0;
      transition: all .9s ease;
      &.grk1{
        background-image: url(../assets/grk.png);
        transform: rotate(-90deg) scale(0.4);
      }
      &.grk2{
        background-image: url(../assets/grk-with-text.png);
      }
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
  }
  &.an1{
    .scTtl{
      opacity: 1;
      transform: none;
    }
    .grkCnt{
      .grk.grk1{
        opacity: 1;
        transform: none;
      }
    }
  }
  &.an2{
    .grkCnt{
      .grk.grk2{
        opacity: 1;
      }
    }
  }
}
.section5{
  background-color: #49C2CC;
  @media (max-width: 960px) {
    padding: 40px 40px 540px;
  }
  @media (max-width: 680px) {
    padding: 30px 16px 360px;
  }
  .sectionItemWrapper{
    z-index: 3;
  }
  .scTtl{
    position: absolute;
    color: #fff;
    line-height: 1.5;
    font-size: 20px;
    right: 100px; top: 100px;
    width: 540px;
    z-index: 3; opacity: 0;
    transition: all .9s ease;
    transform: translateX(600px);
    @media (max-width: 1369px) {
      width: 460px;
      font-size: 18px;
    }
    @media (max-width: 1169px) {
      right: 60px;
      width: 400px;
    }
    @media (max-width: 960px) {
      position: static;
      opacity: 1;
      transform: none;
      width: auto;
      p{
        margin: 0 0 16px;
      }
    }
    @media (max-width: 680px) {
      font-size: 16px;
    }
  }
  .groundBg{
    background-color: #098C7F;
    height: 200px;
    position: absolute;
    left: 0; right: 0; bottom: 0;
    @media (max-width: 1480px) {
      height: 160px;
    }
    @media (max-width: 1369px) {
      height: 140px;
    }
    @media (max-width: 680px) {
      height: 80px;
    }
  }
  .sectionR{
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 1200px; z-index: 3;
    @media (max-width: 1480px) {
      transform: scale(0.9) translate(-100px, 68px);
    }
    @media (max-width: 1369px) {
      transform: scale(0.8) translate(-180px, 114px);
    }
    @media (max-width: 1169px) {
      transform: scale(0.76) translate(-370px, 156px);
    }
    @media (max-width: 960px) {
      transform: scale(0.76) translate(-290px, 156px);
    }
    @media (max-width: 680px) {
      transform: scale(0.50) translate(-840px, 400px);
    }
    .building{
      width: 840px; height: 260px;
      left: 130px; bottom: 170px;
      position: absolute;
      background-image: url(../assets/building-5.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 2; opacity: 0;
      transition: all .9s ease;
      transform: translateY(400px);
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
    .plane{
      width: 290px; height: 74px;
      left: 130px; bottom: 580px;
      position: absolute;
      background-image: url(../assets/plane.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 3; opacity: 0;
      transition: all .9s ease;
      transform: translateX(-340px);
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
    .cloud1{
      width: 120px; height: 60px;
      left: 490px; bottom: 680px;
      position: absolute;
      background-image: url(../assets/cloud-rtl.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 3; opacity: 0;
      transition: all .9s ease;
      transform: translateX(200px);
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
    .cloud2{
      width: 150px; height: 60px;
      left: 680px; bottom: 570px;
      position: absolute;
      background-image: url(../assets/cloud-ltr.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 3; opacity: 0;
      transition: all .9s ease;
      transform: translateX(-200px);
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
    .barrel{
      width: 220px; height: 80px;
      left: 130px; bottom: 150px;
      position: absolute;
      background-image: url(../assets/barrel-5.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 2; opacity: 0;
      transition: all .9s ease;
      transform: translateY(120px);
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
    .cars{
      width: 600px; height: 180px;
      left: 370px; bottom: 116px;
      position: absolute;
      background-image: url(../assets/cars.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 3; opacity: 0;
      transition: all .9s ease;
      transform: translateX(-640px);
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
    .escavator{
      width: 160px; height: 160px;
      left: 940px; bottom: 170px;
      position: absolute;
      background-image: url(../assets/escavator.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 3; opacity: 0;
      transition: all .9s ease;
      transform: translateX(400px);
      @media (max-width: 960px) {
        opacity: 1;
        transform: none;
      }
    }
    .smoke1{
      width: 86px; height: 0;
      left: 279px; bottom: 248px;
      position: absolute;
      background-image: url(../assets/smoke-faktor2.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 1; opacity: 0;
      transition: all .9s ease;
      @media (max-width: 960px) {
        opacity: 1;
        height: 220px; bottom: 268px;
      }
    }
    .smoke2{
      width: 70px; height: 0;
      left: 471px; bottom: 380px;
      position: absolute;
      background-image: url(../assets/smoke2-fakto2.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 1; opacity: 0;
      transition: all .9s ease;
      @media (max-width: 960px) {
        opacity: 1;
        height: 180px; bottom: 406px;
      }
    }
    .smoke3{
      width: 74px; height: 0;
      left: 553px; bottom: 380px;
      position: absolute;
      background-image: url(../assets/smoke3-faktor2.png);
      background-size: contain;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 1; opacity: 0;
      transition: all .9s ease;
      @media (max-width: 960px) {
        opacity: 1;
        height: 260px; bottom: 408px;
      }
    }
  }
  &.an1{
    .scTtl{
      transform: none;
      opacity: 1;
    }
    .sectionR{
      .building, .cloud1, .cloud2, .barrel{
        transform: none;
        opacity: 1;
      }
    }
  }
  &.an2{
    .sectionR{
      .smoke1{
        opacity: 1;
        height: 220px; bottom: 268px;
      }
      .smoke2{
        opacity: 1;
        height: 180px; bottom: 406px;
      }
      .smoke3{
        opacity: 1;
        height: 260px; bottom: 408px;
      }
      .plane, .escavator, .cars{
        transform: none;
        opacity: 1;
      }
    }
  }
}
.section6{
  background-color: #F79552;
  @media (max-width: 960px) {
    padding: 40px;
  }
  @media (max-width: 680px) {
    padding: 30px 16px;
  }
  .sectionL{
    position: absolute;
    left: 100px; top: 50%;
    width: 400px;
    transform: translate(-600px, -50%);
    opacity: 0;
    transition: all .9s ease;
    padding-bottom: 40px;
    @media (max-width: 1169px) {
      left: 60px;
      width: 340px;
    }
    @media (max-width: 960px) {
      position: static;
      width: auto;
      opacity: 1;
      transform: none;
    }
    .scSub{
      color: #fff;
      font-size: 20px;
      margin: 0;
      line-height: 1.5;
      @media (max-width: 1169px) {
        font-size: 18px;
      }
    }
    .earthIcon{
      width: 180px;
      height: 180px;
      position: relative;
      margin-left: 40px;
      margin-bottom: 100px;
      @media (max-width: 1169px) {
        width: 140px; height: 140px;
        margin-bottom: 80px;
      }
      @media (max-width: 960px) {
        margin-left: 0;
        margin-bottom: 60px;
      }
      @media (max-width: 680px) {
        margin: 0 auto 60px;
      }
      .banner5{
        position: absolute;
        left: 0; top: 0;
        width: 180px;
        height: 180px;
        background-image: url(../assets/banner-5.png);
        background-size: 100% auto;
        background-repeat: no-repeat;
        z-index: 2;
        @media (max-width: 1169px) {
          width: 140px; height: 140px;
        }
      }
      .ribbon{
        position: absolute;
        left: 20px; top: 70px; right: 20px;
        height: 110px;
        overflow: hidden;
        background-image: url(../assets/ribbon.png);
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: top center;
        transition: all .9s ease;
        @media (max-width: 960px) {
          top: 110px;
        }
      }
    }
  }
  .sectionR{
    transition: all .9s ease;
    transform: translateX(600px);
    opacity: 0;
    width: calc(100% - 680px);
    position: absolute;
    right: 100px; top: 60px; bottom: 60px;
    display: flex;
    align-items: center;
    @media (max-width: 1169px) {
      right: 60px;
      width: calc(100% - 520px);
    }
    @media (max-width: 960px) {
      opacity: 1;
      position: static;
      width: auto;
      transform: none;
    }
    .theImg{
      margin-left: auto;
      .imgCnt{
        background-color: #fff;
        padding: 40px;
        img{
          width: 100%; height: auto;
        }
      }
      .imgCaption{
        color: #fff;
        text-align: right;
        font-size: 14px;
        margin-top: 8px;
        transform: translateX(600px);
        opacity: 0;
        transition: all .9s ease;
        a{
          color: #DEE47D;
          text-decoration: none;
        }
      }
    }
  }
  &.an1{
    .sectionL{
      opacity: 1;
      transform: translate(0, -50%);
    }
    .sectionR{
      opacity: 1;
      transform: none;
    }
  }
  &.an2{
    .sectionL{
      .earthIcon{
        .ribbon{
          left: 0; top: 130px; right: 0;
          @media (max-width: 1169px) {
            top: 110px;
          }
        }
      }
    }
    .sectionR{
      .theImg{
        .imgCaption{
          opacity: 1;
          transform: none;
        }
      }
    }
  }
}
.section7{
  background-color: #fff;
  @media (max-width: 960px) {
    padding: 40px;
  }
  @media (max-width: 680px) {
    padding: 30px 16px;
  }
  .scTtl{
    color: #444;
    margin: 0;
    position: absolute;
    top: 60px; left: 0; right: 0;
    text-align: center;
    font-weight: 800;
    font-size: 30px;
    transform: translateY(100px);
    opacity: 0;
    transition: all .9s ease;
    z-index: 3;
    @media (max-width: 960px) {
      position: static;
      opacity: 1;
      transform: none;
    }
    @media (max-width: 680px) {
      font-size: 20px;
    }
  }
  .erkCnt{
    margin: 0 100px 0;
    padding-top: 130px;
    display: flex;
    @media (max-width: 680px) {
      flex-wrap: wrap;
    }
    @media (max-width: 960px) {
      margin: 0 -20px;
      padding: 20px 0;
    }
    .erkItem{
      width: 33.33333%;
      position: relative;
      height: 26vw;
      @media (max-width: 680px) {
        width: 100%; height: 100vw;
      }
      .erka{
        position: absolute;
        left: 50%; top: 50%;
        transform: translate(-50%, -50%);
        width: 26vw; height: 26vw;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        opacity: 0;
        transition: all .9s ease;
        @media (max-width: 960px) {
          opacity: 1;
        }
        @media (max-width: 680px) {
          width: 100vw; height: 100vw;
        }
      }
      .erkb{
        width: 26vw; height: 26vw;
        margin: 0 auto;
        transform: rotate(90deg);
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        opacity: 0;
        transition: all .9s ease;
        @media (max-width: 960px) {
          display: none;
        }
      }
      &.erk1{
        .erka{
          background-image: url(../assets/emisi-grk-1a.png);
        }
        .erkb{
          background-image: url(../assets/emisi-grk-1b.png);
        }
      }
      &.erk2{
        .erka{
          background-image: url(../assets/emisi-grk-2a.png);
        }
        .erkb{
          background-image: url(../assets/emisi-grk-2b.png);
        }
      }
      &.erk3{
        .erka{
          background-image: url(../assets/emisi-grk-3a.png);
        }
        .erkb{
          background-image: url(../assets/emisi-grk-3b.png);
        }
      }
    }
  }
  .erkInfo{
    font-weight: 800;
    font-size: 26px;
    position: absolute;
    top: calc(26vw + 150px);
    left: 100px; width: 400px;
    color: #444;
    transform: translateX(-200px);
    opacity: 0;
    transition: all .9s ease;
    @media (max-width: 1369px) {
      font-size: 22px;
      width: 350px;
    }
    @media (max-width: 1169px) {
      position: static;
      width: auto;
      margin: 0 auto 16px;
      text-align: center;
    }
    @media (max-width: 960px) {
      opacity: 1;
      transform: none;
      text-align: left;
      font-size: 18px;
    }
  }
  .erkLegend{
    position: absolute;
    top: calc(26vw + 150px);
    right: 100px; width: 720px;
    display: flex;
    transition: all .9s ease;
    transform: translateX(200px);
    opacity: 0;
    @media (max-width: 1369px) {
      width: 620px;
    }
    @media (max-width: 1169px) {
      position: static;
      margin: 0 auto;
    }
    @media (max-width: 960px) {
      transform: none;
      opacity: 1;
      margin: 0; width: auto;
      display: block;
    }
    .legend{
      width: 28%;
      @media (max-width: 960px) {
        width: auto;
      }
      &.legend1{
        width: 44%;
        @media (max-width: 960px) {
          width: auto;
        }
      }
      .legendItem{
        font-size: 18px;
        padding: 6px 0;
        font-weight: 600;
        position: relative;
        padding-left: 26px;
        .lIcon{
          width: 18px; height: 18px;
          background-color: #ccc;
          border-radius: 50%;
          position: absolute;
          left: 0; top: 9px;
          &.ippu{
            background-color: #FFB800;
          }
          &.sampah{
            background-color: #49C2CC;
          }
          &.pertanian{
            background-color: #098C7F;
          }
          &.energi{
            background-color: #555A84;
          }
          &.kehutanan{
            background-color: #F79552;
          }
        }
      }
    }
  }
  &.an1{
    .scTtl{
      opacity: 1;
      transform: none;
    }
    .erkCnt{
      .erkItem{
        .erkb{
          opacity: 1;
          transform: none;
        }
      }
    }
  }
  &.an2{
    .erkCnt{
      .erkItem{
        .erkb{
          opacity: 0;
        }
        .erka{
          opacity: 1;
        }
      }
    }
    .erkInfo, .erkLegend{
      opacity: 1;
      transform: none;
    }
  }
}
.section8{
  background-color: #098C7F;
  @media (max-width: 960px) {
    padding: 40px 40px 400px;
  }
  @media (max-width: 680px) {
    padding: 30px 16px 260px;
  }
  .ttlAn1, .ttlAn2{
    opacity: 0;
    transform: translateX(-460px);
    transition: all .9s ease;
    @media (max-width: 960px) {
      opacity: 1;
      transform: none;
    }
  }
  .scTtl{
    color: #fff;
    position: absolute;
    left: 100px; top: 50%;
    transform: translate(0, -50%);
    width: 600px;
    font-size: 20px;
    line-height: 1.5;
    padding-bottom: 40px;
    @media (max-width: 1480px) {
      width: 520px;
      font-size: 18px;
    }
    @media (max-width: 1169px) {
      left: 60px;
      width: 480px;
    }
    @media (max-width: 960px) {
      position: static;
      transform: none;
      width: auto;
      p{
        margin: 0 0 16px;
      }
    }
    @media (max-width: 680px) {
      font-size: 16px;
    }
    .factor{
      color: #FFE06A;
      font-size: 24px;
      font-weight: 800;
      margin: 10px 0 0;
    }
    .btn{
      margin-top: 40px;
    }
  }
  .sectionR{
    position: absolute;
    width: 640px; height: 640px;
    right: 100px; top: 50%;
    margin-top: -320px;
    @media (max-width: 1480px) {
      transform: scale(.84);
    }
    @media (max-width: 1369px) {
      transform: scale(.7) translateX(140px);
    }
    @media (max-width: 1169px) {
      transform: scale(.8) translateX(340px);
    }
    @media (max-width: 960px) {
      left: 50%; right: auto; top: auto; bottom: 0;
      margin: 0;
      transform: scale(.7) translate(-50%, 200px);
      margin-left: -60px;
    }
    @media (max-width: 680px) {
      transform: scale(.5) translate(-50%, 420px);
      margin-left: -140px;
    }
    .car{
      width: 620px; height: 420px;
      right: 0; top: 20px;
      position: absolute;
      background-image: url(../assets/Ilustrasi-batu-bara.png);
      background-size: 100% auto;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 3; opacity: 0;
      transform: translateX(460px);
      transition: all .9s ease;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
      }
    }
    .bin{
      width: 386px; height: 360px;
      left: -64px; top: 120px;
      position: absolute;
      background-image: url(../assets/bin.png);
      background-size: 100% auto;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 3; opacity: 0;
      transform: translateY(320px);
      transition: all .9s ease;
      @media (max-width: 960px) {
        transform: none;
        opacity: 1;
      }
    }
  }
  &.an1{
    .ttlAn1{
      opacity: 1;
      transform: none;
    }
    .sectionR{
      .car, .bin{
        opacity: 1;
        transform: none;
      }
    }
  }
  &.an2{
    .ttlAn2{
      opacity: 1;
      transform: none;
    }
  }
}
#bumiKini{
  padding-top: 80px;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  @media (max-width: 960px) {
    overflow: auto;
  }
  @media (max-width: 768px) {
    padding-top: 64px;
  }
}
.sectionItem{
  height: 86vh;
  // background-image: url(../assets/texture-bg.png);
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  .sectionItemWrapper{
    position: relative;
    height: 100%;
    max-width: 1690px;
    margin: 0 auto;
    @media (max-width: 960px) {
      position: static;
    }
  }
  @media (max-width: 960px) {
    height: auto;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width:100%;
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width:100%;
  opacity: 0;
}
.section{
  max-width: 1240px;
  margin: 0 auto;
  padding: 60px 0;
}
</style>
